document.addEventListener("DOMContentLoaded", () => {
    
    const videoSlider = document.getElementById('shopify-block-Ac0tnZ01tQXAvVVg2S__ai_gen_block_0ead8c4_nMW7pi');
    
    function clickPlayButton(btn) {
        const buttonIndex = btn.dataset.playButton;
        videoSlider.querySelectorAll('video').forEach((video) => {
            const videoIndex = video.dataset.videoIndex;

            if(videoIndex != buttonIndex) {
                video.muted = true;
            } else {
                video.muted = false;
            }
            
        });
    }        

    
    if(videoSlider) {                
        videoSlider.querySelectorAll('button').forEach((btn) => {            
            btn.addEventListener('click',() => {
                clickPlayButton(btn);
            });
        });
    }

});